import 'immer';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Dispatch } from 'redux';
import type { PurchaseOrderDeleteInput } from '@repo/api-contract';
import ApiClient from '../../util/api-client';

export interface PurchaseOrderPopupModalState {
  openPurchaseOrderPopupModal: boolean;
  loading: boolean;
}

// Initialize state
const initialState: PurchaseOrderPopupModalState = {
  openPurchaseOrderPopupModal: false,
  loading: false,
};

export const purchaseOrderPopupModalSlice = createSlice({
  name: 'purchaseOrderPopupModal',
  initialState,
  reducers: {
    openPurchaseOrderPopupModal: (state) => ({
      ...state,
      openPurchaseOrderPopupModal: true,
    }),
    closeModal: () => ({
      ...initialState,
    }),
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: action.payload,
    }),
  },
});

export const { openPurchaseOrderPopupModal, closeModal, setLoading } =
  purchaseOrderPopupModalSlice.actions;
export default purchaseOrderPopupModalSlice.reducer;

// Thunks
export const deletePurchaseOrder =
  (deleteInput: PurchaseOrderDeleteInput) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      dispatch(setLoading(true));
      await ApiClient.deletePurchaseOrder.mutate(deleteInput);
    } finally {
      dispatch(setLoading(false));
    }
  };
